import { TransactionHistoryDto } from '../../../dto/transactionhistory/transactionhistorydto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface TransactionHistoryRequest extends APIRequest
{
    getTransactionHistoryRequest(): TransactionHistoryDto;
}

export class TransactionHistoryRequestImpl extends APIRequestDtoImpl implements TransactionHistoryRequest
{
    constructor(private transactionHistoryDtoData: TransactionHistoryDto)
    {
        super();
    }

    getTransactionHistoryRequest(): TransactionHistoryDto
    {
        return this.transactionHistoryDtoData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/myaccount/transactionhistory/transactionhistoryrequest.tsx